import { TONE_TEXT, type Kpi } from "./model";

const TOP: Record<string, string> = { ink: "var(--ink)", acc: "var(--acc)", err: "var(--err)", ok: "var(--ok)", warn: "var(--warn)", mut: "var(--bd)", ink2: "var(--bd2)" };

/** KPI-плитки A3: число mono 24, подпись, пояснение; верхняя кромка в тон числа. */
export function Kpis({ items }: { items: Kpi[] }) {
  return (
    <div className="grid grid-cols-2 gap-3 xl:grid-cols-4" data-testid="kpis">
      {items.map((k) => (
        <div key={k.testId} className="rounded-md border border-bd bg-card px-4 py-3.5" style={{ borderTop: `2px solid ${TOP[k.tone] ?? "var(--bd)"}` }} data-testid={k.testId}>
          <div className={`font-mono text-[24px] font-bold leading-none ${TONE_TEXT[k.tone]}`} data-testid="kpi-value">
            {k.v}
          </div>
          <div className="mt-2 font-mono text-[12px] text-ink2">{k.label}</div>
          <div className="mt-0.5 text-[11.5px] text-mut" data-testid="kpi-note">
            {k.note}
          </div>
        </div>
      ))}
    </div>
  );
}
